import React from "react";
import { Box, Typography, Chip, Paper } from "@mui/material";
import styled from "styled-components";
import colors from "../../theme/colors";

const StatusCard = styled(Paper)`
  padding: 20px 15px;
  width: 100%;
  max-width: 400px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const HeaderSection = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
`;

const Title = styled(Typography)`
  && {
    font-weight: bold;
    color: ${colors.grayDarkText};
    font-size: 12px;
  }
`;
const StatusChip = styled(Chip)`
  && {
    font-weight: bold;
    border-radius: 12px;
    border-color: ${colors.grayLight};
    color: ${colors.grayDarkText};
    background-color: ${colors.grayLightest};

    &.green {
      border-color: ${colors.green};
      color: ${colors.green};
      background-color: ${colors.greenLightestSuccess};
    }
    &.red {
      border-color: ${colors.redError};
      color: ${colors.redError};
      background-color: ${colors.redLightError};
    }
    &.gray {
      border-color: ${colors.gray};
      color: ${colors.gray};
      background-color: ${colors.grayLightest};
    }
  }
`;

const OnlineStatusText = styled(Typography)`
  && {
    color: ${colors.green}; /* Dynamically matches your theme success green */
    font-weight: bold;
    font-size: 20px;
    margin-bottom: 12px;
  }
`;

const DataReceivedText = styled(Typography)`
  && {
    color: ${colors.grayDarkText};
    font-size: 11px;
    font-weight: 500;
    margin-bottom: 6px;
  }
`;

const ThresholdLabel = styled(Typography)`
  && {
    color: ${colors.grayDarkText};
    font-size: 12px;
  }
`;

export function ConnectivityStatus({
  metricTitle = "Connectivity Status",
  isOnline = true,
  lastReceivedTimestamp = "--",
  alarmThresholdHours = 3.5,
  isLoading = true,
}) {

  let statusChipClass = isOnline ? "green" : "red";
  let statusChipLabel = isOnline ? "healthy" : "unhealthy";
  if(isLoading) {
    statusChipClass = "gray";
    statusChipLabel = "loading";
  }

  return (
    <StatusCard>
      {/* Upper Status Banner Row */}
      <HeaderSection>
        <Title>{metricTitle.toUpperCase()}</Title>
        <StatusChip
          label={statusChipLabel}
          variant="outlined"
          size="small"
          className={statusChipClass}
        />
      </HeaderSection>

      {/* Hero Visual State */}
      <OnlineStatusText>{isOnline ? "ONLINE" : "OFFLINE"}</OnlineStatusText>

      {/* Explicit Metadata Disclosures */}
      <Box>
        <DataReceivedText>
          DATA LAST RECEIVED: {lastReceivedTimestamp}
        </DataReceivedText>

        <ThresholdLabel>
          Offline Alarm Threshold: {">"} <b>{alarmThresholdHours} hrs</b>
        </ThresholdLabel>
      </Box>
    </StatusCard>
  );
}

export default ConnectivityStatus;
